import LogService from "../../../../../react/core/services/logService";
import { getEnvironment } from "../../../../../react/core/utils/getEnvironment";
import gaTags from "./gaTags";

const getGoogleAnalyticsId = ({ method, currentHost }) => {
    let useDevAnalyticsId = getEnvironment(currentHost);

    const googleAnalyticsId = useDevAnalyticsId
        ? gaTags["googleAnalyticsId.dev"]
        : gaTags["googleAnalyticsId.prod"];

    LogService.getLogger().debug("{0}- Found [{1}] value=[{2}]", [method, googleAnalyticsId]);
    return googleAnalyticsId;
};

export default getGoogleAnalyticsId;
